export default "__VITE_ASSET__CXxbeF9V__"